import { useEffect, useState } from 'react';
import { ref, onValue } from 'firebase/database';
import { database } from './firebaseConfig';
import { hasActiveSubscription } from './subscription';
import './Watermark.css';

// Водяний знак прибирає будь-яка активна підписка (Стандарт або Преміум)

export default function Watermark({ chatId }) {
  const [subscribed, setSubscribed] = useState(true); // до завантаження даних водяного знаку не показуємо

  useEffect(() => {
    if (!chatId) return;
    const userRef = ref(database, `users/${chatId}`);
    const unsub = onValue(userRef, (snapshot) => {
      setSubscribed(hasActiveSubscription(snapshot.val()));
    });
    return () => unsub();
  }, [chatId]);

  if (subscribed) return null;

  const tiles = Array.from({ length: 120 });

  return (
    <div className="watermark-overlay">
      <div className="watermark-grid">
        {tiles.map((_, i) => (
          <span key={i} className="watermark-text">бараболя</span>
        ))}
      </div>
    </div>
  );
}
